// extracted by mini-css-extract-plugin
module.exports = {"root":"navigation-module__root___SLeL0","back":"navigation-module__back___1XapS","edit":"navigation-module__edit___OYe3b"};